package api

sealed class LicenseState(val mask: Int) {
    data object IDLE : LicenseState(2)
    data object REVIEW : LicenseState(4)
    data object APPROVED : LicenseState(8)
    data object DECLINED : LicenseState(16)
    data object TERMINATED : LicenseState(32)

    infix fun match(mask: Int): Boolean = this.mask == mask

    companion object {
        val all by lazy {
            listOf(IDLE, REVIEW, APPROVED, DECLINED, TERMINATED)
        }

        operator fun get(mask: Int): LicenseState {
            return all.firstOrNull {
                it.mask == mask
            } ?: IDLE
        }
    }
}
